import React from "react";

/**
 * ImageFrame
 * If the post has the "crop" tag → object-fit: cover, no blur.
 * Otherwise → object-fit: contain + blurred background fill.
 */
const ImageFrame = ({ post, src, alt, frameClass = "info-image-frame" }) => {
  const tags = post?._embedded?.["wp:term"]
    ?.flat()
    ?.filter((t) => t.taxonomy === "post_tag") ?? [];
  const crop = tags.some((t) => t.slug === "crop" || t.name === "crop");

  if (crop) {
    return (
      <div className={frameClass} style={{ background: "none" }}>
        <img
          src={src}
          alt={alt}
          className="info-image info-image--crop"
          loading="lazy"
        />
      </div>
    );
  }

  return (
    <div className={frameClass}>
      <div
        className="info-image-blur"
        style={{ backgroundImage: `url(${src})` }}
        aria-hidden="true"
      />
      <img
        src={src}
        alt={alt}
        className="info-image"
        loading="lazy"
      />
    </div>
  );
};

export default ImageFrame;